 import shape from "../../assets/images/all-img/blog2/shape.png";
import shape2 from "../../assets/images/all-img/v3/shape2.png";
import BlogFilterning from "../blog-light/blog-filtering";
import BlogTopSection from "../blog-light/blog-top-section";
import BreadcrumbsSection from "../blog-light/breadcrumbs-section";
import BlogPaginationDark from "./blog-pagination";

export default function BlogDarkInnerSection() {
	return (
		<div className="fugu--inner-section dark-version">
			<div className="container">
				<BreadcrumbsSection />
				<BlogTopSection />
				<BlogFilterning />
				<BlogPaginationDark />
			</div>

			<div className="fugu--blog-shape1">
				<img src={shape2} alt="" />
			</div>
			<div className="fugu--blog-shape3">
				<img src={shape} alt="" />
			</div>
		</div>
	);
}
